import { createContext, useContext } from 'react';

export const TextNestingContext = createContext(false);

export function useIsInsideText() {
  return useContext(TextNestingContext);
}
